<template>
  <div id="app">
    <Spinner v-if="spin.val" />
    <div v-if="!isAuthenticated" class="login-wrapper">
      <router-view :key="$route.fullPath"></router-view>

    </div>


    <div class="container" v-if="isAuthenticated">
      <app-header />
       <router-view :key="$route.fullPath"></router-view>
       <app-footer />
    </div>

  </div>
</template>

<script>
import Header from "./components/header/header.vue";
import Footer from "./components/footer/footer.vue";
import elMessages from "devextreme/localization/messages/el.json";
import { locale, loadMessages } from "devextreme/localization";
import Spinner from './components/shared/sppinner.vue';

export default {
  name: "app",
  components: {
    "app-header": Header,
    "app-footer": Footer,
    Spinner
  },
  data:()=>({
    spin:{
      val:false
    }
  }),
  provide(){
    return {
      mySpinner: this.spin
    }
  },
  created() {
    loadMessages(elMessages);
    locale("el");
    this.$store.dispatch("tryAutoLogin");
  },
  methods: {},
  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
  },
};
</script>

<style>
body,
html {
  margin: 0;
}
.login-wrapper {
    width: 100%;
    height: 100%;
}
</style>
